import { put, select, takeLatest } from 'redux-saga/effects'
import * as actions from '../store/configurations.actions'
import { IConfigurationsState } from '../store/configurations.types'
import { getConfigurationsSelector } from '../selectors/configurations.selector'
import { PickupAddressConstants } from '../../pickupAddress/store/pickupAddress.constants'
import { getPickupAddressSelector } from '../../pickupAddress/selectors'
import { TripInformationConstants } from '../../tripInformation/store/tripInformation.constants'
import { IPickupAddressState } from '../../pickupAddress/store/pickupAddress.types'
import { getTripInformationSelector } from '../../tripInformation/selectors'
import { ITripInformationState } from '../../tripInformation/store/tripInformation.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'

export function* updateAgencyNumber() {
  const { agencyNumberConfig }: IConfigurationsState = yield select(getConfigurationsSelector)
  const { county }: IPickupAddressState = yield select(getPickupAddressSelector)
  const { base, unit }: ITripInformationState = yield select(getTripInformationSelector)

  let didUpdateAgencyNumber = false

  // For each state/dataset, set the agency number based on the following priority:
  // County > Unit > Base > General
  for (const datasetConfig of agencyNumberConfig) {
    let newAgencyNumber = datasetConfig.originalAgencyNumber

    datasetConfig.baseOverrides?.forEach((baseOverride) => {
      if (baseOverride.id === base?.id) {
        newAgencyNumber = baseOverride.agencyNumber
      }
    })

    datasetConfig.unitOverrides?.forEach((unitOverride) => {
      if (unitOverride.id === unit?.id) {
        newAgencyNumber = unitOverride.agencyNumber
      }
    })

    datasetConfig.countyOverrides?.forEach((countyOverride) => {
      if (countyOverride.id === county?.id) {
        newAgencyNumber = countyOverride.agencyNumber
      }
    })

    if (newAgencyNumber !== datasetConfig.agencyNumber) {
      yield put(actions.setAgencyNumber(newAgencyNumber, datasetConfig.dataset))
      didUpdateAgencyNumber = true
    }
  }

  if (didUpdateAgencyNumber) {
    yield put(actions.saveAgencyNumber())
  }
}

export function* updateAgencyNumberSaga() {
  yield takeLatest(
    [PickupAddressConstants.SET_COUNTY, TripInformationConstants.SET_BASE, TripInformationConstants.SET_UNIT],
    performWithMutexHOG,
    updateAgencyNumber
  )
}
